import store from "@/store";
import PersonalizerApi from "@/services/personalizer_api";
import { UPDATE_INTERACTIONS } from "@/store/_actiontypes";
import getEnv from "@/config/env";

function getBrowserName() {
  const userAgent = navigator.userAgent;
  if (userAgent.includes("Firefox")) return "Firefox";
  if (userAgent.includes("SamsungBrowser")) return "Samsung Internet";
  if (userAgent.includes("Opera") || userAgent.includes("OPR")) return "Opera";
  if (userAgent.includes("Trident")) return "Internet Explorer";
  if (userAgent.includes("Edge")) return "Edge";
  if (userAgent.includes("Chrome")) return "Chrome";
  if (userAgent.includes("Safari")) return "Safari";
  return "Unknown Browser";
}

const actions = {
  [UPDATE_INTERACTIONS](
    _,
    {
      interaction_point = "",
      text_in_interaction_point = "",
      interaction_value = "",
    }
  ) {
    return new Promise((resolve) => {
      const userProfile = store.getters["account/userProfile"] || {};
      let data = {
        user_id: userProfile?.id || getEnv("VUE_APP_DEFAULT_USER_ID"),
        member_id: userProfile?.id || getEnv("VUE_APP_DEFAULT_MEMBER_ID"),
        interaction_point: interaction_point,
        page_url: window.location.href,
        text_in_interaction_point: text_in_interaction_point,
        device_type: /Mobi|Android/i.test(navigator.userAgent)
          ? "mobile"
          : /iPad|Tablet/i.test(navigator.userAgent)
          ? "tablet"
          : "desktop",
        browser_info: getBrowserName(),
        referrer_url: document.referrer || window.location.href,
        interaction_value: interaction_value,
      };

      PersonalizerApi.post(`interactions`, data).then(
        (response) => {
          resolve(response.data.detail.response);
        },
        (error) => {
          console.error("Error in UPDATE_INTERACTIONS action:", error);
          return null;
        }
      );
    });
  },
};

export const interactions = {
  namespaced: true,
  actions,
};
